import {
  Bell,
  BookOpen,
  Building,
  Calendar,
  Car,
  Database,
  Activity,
  ListOrdered,
  MessageSquare,
  MoreHorizontal,
  Route,
  Settings,
  Shield,
  User,
  Users
} from 'lucide-react';
import { isAdmin, isDriver, isSystemAdmin } from '../../utils/roleUtils';

const translate = (t, key) => (typeof t === 'function' ? t(key) : key);

export const buildMobileNavigationItems = ({
  userRole,
  t,
  showNotificationMenu = false,
  showNotificationManagementMenu = false,
  showSurveyMenu = false,
  showUserSurveyMenu = false
} = {}) => {
  const tabs = [
    {
      id: 'bookings',
      label: translate(t, 'bookings'),
      path: '/bookings',
      icon: BookOpen
    },
    {
      id: 'trips',
      label: translate(t, 'trips'),
      path: '/trips',
      icon: ListOrdered
    }
  ];

  if (isDriver(userRole)) {
    tabs.push({
      id: 'operations',
      label: translate(t, 'operations.title'),
      path: '/operations',
      icon: Activity
    });
  }

  tabs.push({
    id: 'more',
    label: translate(t, 'more'),
    icon: MoreHorizontal
  });

  const moreItems = [
    {
      id: 'profile',
      label: translate(t, 'profileInformation'),
      path: '/settings/account',
      icon: User,
      section: 'account'
    },
    {
      id: 'security',
      label: translate(t, 'securitySettings'),
      path: '/settings/security',
      icon: Shield,
      section: 'account'
    },
    {
      id: 'preferences',
      label: translate(t, 'displaySettings'),
      path: '/settings/preferences',
      icon: Settings,
      section: 'preferences'
    },
    ...(showNotificationMenu
      ? [
          {
            id: 'notifications',
            label: translate(t, 'notifications'),
            path: '/settings/notifications',
            icon: Bell,
            section: 'preferences'
          }
        ]
      : []),
    ...(showUserSurveyMenu
      ? [
          {
            id: 'feedback-surveys',
            label: translate(t, 'feedbackSurveys'),
            path: '/settings/feedback-surveys',
            icon: MessageSquare,
            section: 'preferences'
          }
        ]
      : [])
  ];

  if (isAdmin(userRole)) {
    moreItems.push(
      {
        id: 'vehicles',
        label: translate(t, 'Vehicles'),
        path: '/vehicles',
        icon: Car,
        section: 'administration'
      },
      {
        id: 'gps-devices',
        label: translate(t, 'gpsDevices.title'),
        path: '/gps-devices',
        icon: Database,
        section: 'administration'
      },
      {
        id: 'routes',
        label: translate(t, 'Routes'),
        path: '/routes',
        icon: Route,
        section: 'administration'
      },
      {
        id: 'schedules',
        label: translate(t, 'Schedules'),
        path: '/schedule-management',
        icon: Calendar,
        section: 'administration'
      },
      {
        id: 'organization',
        label: translate(t, 'organizationSettings'),
        path: '/settings/organization',
        icon: Building,
        section: 'administration'
      }
    );

    if (showSurveyMenu) {
      moreItems.push({
        id: 'survey-management',
        label: translate(t, 'surveyManagement'),
        path: '/settings/surveys',
        icon: MessageSquare,
        section: 'administration'
      });
    }

    if (showNotificationManagementMenu) {
      moreItems.push({
        id: 'notification-management',
        label: translate(t, 'notificationManagement'),
        path: '/settings/notification-management',
        icon: Bell,
        section: 'administration'
      });
    }
  }

  if (userRole) {
    moreItems.push({
      id: 'users',
      label: isAdmin(userRole) ? translate(t, 'userManagement') : translate(t, 'inviteUsers'),
      path: '/settings/users',
      icon: Users,
      section: isAdmin(userRole) ? 'administration' : 'account'
    });
  }

  if (isSystemAdmin(userRole)) {
    moreItems.push({
      id: 'system',
      label: translate(t, 'systemAdministration'),
      path: '/settings/system',
      icon: Database,
      section: 'system'
    });
  }

  return { tabs, moreItems };
};

export default buildMobileNavigationItems;
